import { useContextState } from "../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        statusCount: {
            display: 'flex',
            gap:'5px',
            padding: '5px 8px',
            alignItems: 'center'
        },
        circle : (color:string) => ({ 
            borderRadius: '50%', 
            backgroundColor: color, 
            height: '8px', 
            width: '8px' 
        }),
        number: {
            fontSize:'16px',
            paddingRight: '5px',
            borderRight: `1px solid ${colors.color10}`
        }
    }
}

export { useStyles }
